import React from "react";

import { faRectangleHistory } from "@awesome.me/kit-4c83d50d0d/icons/classic/regular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { dispatchAnalyticsTrack } from "~/lib/segment";
import { useFilterRecordingsByCompany } from "~/recordings/Filters/hooks/useFilterRecordingsByCompany";
import JumpToResultWrapper from "~/search/JumpTo/JumpToResult/JumpToResultWrapper";

import { JumpToContext } from "../JumpToContext";

import type { JumpToResultSearch_result$data as JumpToResultType } from "~/__generated__/JumpToResultSearch_result.graphql";

interface JumpToExternalCompanyResultProps {
	company: Extract<JumpToResultType, { __typename: "ExternalCompany" }>;
	index?: number;
}

export default function JumpToExternalCompanyResult({ company, index }: JumpToExternalCompanyResultProps) {
	const { onClose } = React.useContext(JumpToContext);
	const goToFilteredRecordings = useFilterRecordingsByCompany(company.name, "/library");

	const onClick = React.useCallback(() => {
		goToFilteredRecordings();
		onClose();
		dispatchAnalyticsTrack("Jump to search used for company filter", {
			feature: "search",
			company: company.name,
		});
	}, [goToFilteredRecordings, onClose, company.name]);

	return (
		<JumpToResultWrapper
			index={index}
			icon={<FontAwesomeIcon icon={faRectangleHistory} />}
			title={`View all meetings with ${company.name}`}
			onSelect={onClick}
		/>
	);
}
